"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpsError = void 0;
class UpsError extends Error {
    constructor(name, message, details = {}) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(message);
        this.details = () => ({ ...this._details });
        this._details = details || {};
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UpsError);
        }
        this.name = name;
    }
    addDetail(key, value) {
        this._details[key] = value;
    }
}
exports.UpsError = UpsError;
//# sourceMappingURL=UpsError.js.map